import script from "./InvestActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestActions.vue?vue&type=script&setup=true&lang=ts"

export default script